import React from 'react'

export type TagSelectorTagsProps = string[]
type TagSelectorProps = {
    tags: TagSelectorTagsProps
    activeTag: string
    setActiveTag: React.Dispatch<string>
    disabled?: boolean
    suppressActiveTag?: boolean
}

export const TagSelector: React.FC<TagSelectorProps> = ({ tags, activeTag, setActiveTag, disabled, suppressActiveTag }) => {
    const menu = tags.map((title, i) => {
        const classList = !suppressActiveTag && activeTag === title ? 'tag-selector-item active-tag' : 'tag-selector-item'

        return (
            <React.Fragment key={i}>
                <span className={classList}>
                    <button className={title.toLocaleLowerCase().replaceAll(' ', '-')} onClick={() => setActiveTag(title)} disabled={disabled}>{title}</button>
                </span>
            </React.Fragment>
        )
    })

    return <div className='tag-selector'>{menu}</div>
}
